import SVG from "@Components/Icons/SVG";
export default class No extends SVG {
    path = [
        "M 50 98 C 78 98 100 76 100 49 C 100 36 95 24 85 14 C 76 5 63 0 50 0 C 22 0 0 22 0 49 C 0 62 5 75 15 84 C 24 93 37 98 50 98 Z M 50 92 C 41 92 28 88 21 81.5 L 83 20.5 C 89 27 94 41 94 49 C 94 71 72 92 50 92 Z M 50 6 C 59 6 72 10 79 16.5 L 17 77.5 C 11 71 6 58 6 49 C 6 28 28 6 50 6 Z",
    ];
    evenOdd = true;
}
